import { Component, inject, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SettingService } from '../../../layout/header/Services/header.service';

import { AuthService } from '../../../shared/service/auth.service';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { ApplyForMembershipComponent } from "../apply-for-membership/apply-for-membership.component";
import { MembershipStatusComponent } from "../membership-status/membership-status.component";
import { MembershipService } from '../memberships/Services/Membership.service';
import { StatusService } from '../memberships/Services/status.service';

@Component({
  selector: 'app-account',
  imports: [TranslateModule, ReactiveFormsModule, CommonModule, RouterOutlet, RouterLink, RouterModule, ToasterComponent, ApplyForMembershipComponent, MembershipStatusComponent],
  templateUrl: './myAccount.component.html',
  styleUrl: './myAccount.component.css'
})
export class MyAccountComponent {

  id: number | null = null;
  isAdmin: boolean = localStorage.getItem("isAdmin") === 'true'
  isMember: boolean = localStorage.getItem("isMember") === 'true'
  membershipStatus = signal<string>('');
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  isUserCreatedBefore: boolean = localStorage.getItem("isUserCreatedBefore") === 'true'


  private settingService = inject(SettingService)
  private router = inject(Router);
  private authService = inject(AuthService);
  private translate = inject(TranslateService)
  StatusService = inject(StatusService);


  ngOnInit(): void {

    // console.log("this.isUserCreatedBefore", this.isUserCreatedBefore)
  }


  onMembershipStatusChanged(status: string) {
    // console.log("this.membershipStatus()", this.membershipStatus());
    this.membershipStatus.set(status);
  }

  logout() {
    let userId: any
    userId = localStorage.getItem('userId');
    const params = {
      "userID": userId
    };
    this.settingService.logout(params).subscribe({
      next: (res) => {
        this.toastType = 'success';
        this.toastMessage = this.translate.instant('LOGOUT.SUCCESS');
        this.showToast = true;
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        localStorage.removeItem("userId");
        localStorage.removeItem("isMember");
        localStorage.removeItem("userName");
        localStorage.removeItem("isAdmin");
        setTimeout(() => this.showToast = false, 3000);
        setTimeout(() =>
          this.router.navigate(['/home'])
          , 2000);
        this.authService.setLoggedOut();
      },
      error: (err) => {
        this.toastMessage = this.translate.instant('LOGOUT.ERROR');
      }
    });
  }

}
